import AuthUser from "../../component/Auth";

const Auth = () => {
  return (
    <>
      <AuthUser />
    </>
  );
};

export default Auth;
